export const toQueryParams = (key: string, values: readonly (string | number)[]): string =>
  values.length === 0 ? "" : `?${values.map((value) => `${key}=${value}`).join("&")}`;
